import { createRouter, createWebHistory } from "vue-router"
import AppLayout from "@/layout/AppLayout.vue"
import ls from "@/helper/ls"

const routes = [
  {
    path: "/",
    component: AppLayout,
    children: [
      {
        path: "/",
        name: "home",
        component: () => import("@/views/pages/Home.vue"),
      },
      {
        path: "/generate",
        name: "generate",
        component: () => import("@/views/pages/Generate.vue"),
      },
      {
        path: "/chat",
        name: "chat",
        component: () => import("@/views/pages/Chat.vue"),
      },

      {
        path: "/admin/users",
        name: "users",
        component: () => import("@/views/pages/admin/Users.vue"),
      },
      {
        path: "/admin/contents",
        name: "user-contents",
        component: () => import("@/views/pages/admin/UsersContents.vue"),
      },
      {
        path: "/admin/dialogs",
        name: "user-dialogs",
        component: () => import("@/views/pages/admin/UserDialogs.vue"),
      },
      {
        path: "/contents",
        name: "contents",
        component: () => import("@/views/pages/Contents.vue"),
      },
      {
        path: "/dialogs",
        name: "dialogs",
        component: () => import("@/views/pages/Dialogs.vue"),
      },
      {
        path: "/life",
        name: "Игра Жизнь",
        component: () => import("@/views/pages/Life.vue"),
      },
      //test
      {
        path: "/empty",
        name: "empty",
        component: () => import("@/views/pages/Empty.vue"),
      },
      {
        path: "/documentation",
        name: "documentation",
        component: () => import("@/views/pages/Documentation.vue"),
      },
    ],
  },

  {
    path: "/notfound",
    name: "notfound",
    component: () => import("@/views/pages/NotFound.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/pages/auth/Login.vue"),
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/views/pages/auth/Register.vue"),
  },
  {
    path: "/auth/access",
    name: "accessDenied",
    component: () => import("@/views/pages/auth/Access.vue"),
  },
  {
    path: "/auth/error",
    name: "error",
    component: () => import("@/views/pages/auth/Error.vue"),
  },
  {
    path: "/forgot",
    name: "forgotPassword",
    component: () => import("@/views/pages/auth/ForgotPassword.vue"),
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach((to, from, next) => {
  const adminPages = [
    "/admin/users",
    "/admin/contents",
    "/admin/dialogs",
    "/documentation",
  ]
  const isAdminPage = adminPages.includes(to.path)

  const publicPages = ["/login", "/register", "/forgot"]
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = ls.getKey("baltlan_ai")

  const isAdmin = loggedIn?.roles?.some((role) => role === "Администратор")

  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next("/login")
  } else {
    const isPageExist = routes.some((route) => {
      if (route.path === to.path) {
        return true
      }

      if (route.children?.length) {
        const isChildrenExist = route.children.some(
          (cpath) => cpath.path === to.path
        )
        if (isChildrenExist) {
          return true
        }
      }
    })

    if (!isPageExist) {
      next("/notfound")
    } else {
      if (isAdminPage && !isAdmin) {
        next("/auth/access")
      }

      next()
    }
  }
})

export default router
